import React from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/shared/Header";
import Footer from "../../components/shared/Footer";
import ExamFeature from "../../components/exam/ExamFeature";
import WhatsAppEnquiryButton from '../../components/shared/WhatsAppEnquiryButton';

const ExamPapers = [
  { // Sec 1
    id: "sec-1",
    level: "Secondary 1",
    subText: "Targeted practice papers for quick improvement",
    subject: "Math",
    header: "Practice Questions by Topics",
    subHeader: "Work through these Secondary 1 mathematics questions to identify areas where you may need additional support. If you're short on time and already know which concepts are challenging for you, focus your practice on those specific topics that require the most attention.",
    items: [
      {
        title: "HCF & LCM",
        img: "/images/site/exam/sec-1/hcf-and-lcm.webp",
        link: "/docs/exam-papers/sec-1/1. 7 ESSENTIAL QUESTIONS TO MASTER HCF & LCM.pdf"
      },
      {
        title: "Numbers",
        img: "/images/site/exam/sec-1/numbers.webp",
        link: "/docs/exam-papers/sec-1/2. 8 ESSENTIAL QUESTIONS TO MASTER NUMBERS.pdf"
      },
      {
        title: "Approximation & Estimation",
        img: "/images/site/exam/sec-1/approximation-and-estimation.webp",
        link: "/docs/exam-papers/sec-1/3. 8 ESSENTIAL QUESTIONS TO MASTER APPROXIMATION AND ESTIMATION.pdf"
      },
      {
        title: "Basic Algebra",
        img: "/images/site/exam/sec-1/basic-algebra.webp",
        link: "/docs/exam-papers/sec-1/4. 8 ESSENTIAL QUESTIONS TO MASTER- BASIC ALGEBRA.pdf"        
      },
      {
        title: "Linear Equations & Simple Inequalities",
        img: "/images/site/exam/sec-1/linear-equations-and-simple-inequalities.webp",
        link: "/docs/exam-papers/sec-1/5. 8 ESSENTIAL QUESTIONS TO MASTER LINEAR EQUATIONS & SIMPLE INEQUALITIES.pdf"
      },
      {
        title: "Functions & Linear Graphs",
        img: "/images/site/exam/sec-1/functions-and-linear-graphs.webp",
        link: "/docs/exam-papers/sec-1/6. 8 ESSENTIAL QUESTIONS TO MASTER FUNCTIONS & LINEAR GRAPHS.pdf"
      },
      {
        title: "Number Patterns",
        img: "/images/site/exam/sec-1/number-patterns.webp",
        link: "/docs/exam-papers/sec-1/7. 6 ESSENTIAL QUESTIONS TO MASTER NUMBER PATTERNS.pdf"
      },
      {
        title: "Percentage",
        img: "/images/site/exam/sec-1/percentage.webp",
        link: "/docs/exam-papers/sec-1/8. 8 ESSENTIAL QUESTIONS TO MASTER PERCENTAGE.pdf"
      },
      {
        title: "Ratio & Rate",
        img: "/images/site/exam/sec-1/ratio-and-rate.webp",
        link: "/docs/exam-papers/sec-1/9. 7 ESSENTIAL QUESTIONS TO MASTER RATIO & RATE.pdf"
      },
      {
        title: "Basic Geometry",
        img: "/images/site/exam/sec-1/basic-geometry.webp",
        link: "/docs/exam-papers/sec-1/10. 8 ESSENTIAL QUESTIONS TO MASTER BASIC GEOMETRY.pdf"
      },
      {
        title: "Polygons & Geometrical Constructions",
        img: "/images/site/exam/sec-1/polygons-and-geometrical-constructions.webp",
        link: "/docs/exam-papers/sec-1/11. 8 ESSENTIAL QUESTIONS TO MASTER POLYGONS & GEOMETRICAL CONSTRUCTIONS.pdf"
      },
  ]},
  { // Sec 2
    id: "sec-2",
    level: "Secondary 2",
    subText: "Targeted practice papers for quick improvement",
    subject: "Math",
    header: "Practice Questions by Topics",
    subHeader: "Work through these Secondary 2 mathematics questions to identify areas where you may need additional support. If you're short on time and already know which concepts are challenging for you, focus your practice on those specific topics that require the most attention.",
    items: [
      {
        title: "Simultaneous Equations",
        img: "/images/site/exam/sec-2/simultaneous-equations.webp",
        link: "/docs/exam-papers/sec-2/1. 8 ESSENTIAL QUESTIONS TO MASTER SIMULTANEOUS EQUATIONS.pdf"
      },
      {
        title: "Linear Inequalities",
        img: "/images/site/exam/sec-2/linear-inequalities.webp",
        link: "/docs/exam-papers/sec-2/2. 6 ESSENTIAL QUESTIONS TO MASTER LINEAR INEQUALITIES.pdf"
      },
      {
        title: "Expansion & Factorisation",
        img: "/images/site/exam/sec-2/expansion-and-factorisation.webp",
        link: "/docs/exam-papers/sec-2/3. 8 ESSENTIAL QUESTIONS TO MASTER EXPANSION & FACTORISATION.pdf"
      },
      {
        title: "Quadratic Functions & Equations",
        img: "/images/site/exam/sec-2/quadratic-functions-and-equations.webp",
        link: "/docs/exam-papers/sec-2/4. 8 ESSENTIAL QUESTIONS TO MASTER QUADRATIC FUNCTIONS & EQUATIONS.pdf"
      },
      {
        title: "Simple Algebraic Fractions & Formula",
        img: "/images/site/exam/sec-2/simple-algebraic-fractions-and-formula.webp",
        link: "/docs/exam-papers/sec-2/5. 9 ESSENTIAL QUESTIONS TO MASTER SIMPLE ALGEBRAIC FRACTIONS.pdf"
      },
      {
        title: "Proportion",
        img: "/images/site/exam/sec-2/proportion.webp",
        link: "/docs/exam-papers/sec-2/6. 7 ESSENTIAL QUESTIONS TO MASTER PROPORTION.pdf"
      },
      {
        title: "Congruence & Similarity",
        img: "/images/site/exam/sec-2/congruence-and-similarity.webp",
        link: "/docs/exam-papers/sec-2/7. 7 ESSENTIAL QUESTIONS TO MASTER CONGRUENCE & SIMILARITY.pdf"
      },
      {
        title: "Pythagoras' Theorem",
        img: "/images/site/exam/sec-2/pythagoras-theorem.webp",
        link: "/docs/exam-papers/sec-2/8. 6 ESSENTIAL QUESTIONS TO MASTER PHYTHAGORAS’ THEOREM.pdf"
      },
      {
        title: "Trigonometric Functions",
        img: "/images/site/exam/sec-2/trigonometric-functions.webp",
        link: "/docs/exam-papers/sec-2/9. 8 ESSENTIAL QUESTIONS TO MASTER TRIGONOMETRIC FUNCTIONS.pdf"
      },
      {
        title: "Mensuration",
        img: "/images/site/exam/sec-2/mensuration.webp",
        link: "/docs/exam-papers/sec-2/10. 6 ESSENTIAL QUESTIONS TO MASTER MENSURATION.pdf"
      },
      {
        title: "Probability & Statistics",
        img: "/images/site/exam/sec-2/probability-and-statistics.webp",
        link: "/docs/exam-papers/sec-2/11. 9 ESSENTIAL QUESTIONS TO MASTER PROBABILITY & STATISTICS.pdf"
      },
  ]},
  { // Sec 3
    id: "sec-3",
    level: "Secondary 3",
    subText: "Targeted practice papers for quick improvement",
    subject: "E-Math",
    header: "Practice Questions by Topics",
    subHeader: "Work through these Secondary 3 E-Math questions to identify areas where you may need additional support. If you're short on time and already know which concepts are challenging for you, focus your practice on those specific topics that require the most attention.",
    items: [
      {
        title: "Algebra",
        img: "/images/site/exam/sec-3/algebra.webp",
        link: "/docs/exam-papers/sec-3/1. 7 ESSENTIAL QUESTIONS TO MASTER ALGEBRA.pdf"
      },
      {
        title: "Arc Sector Segment",
        img: "/images/site/exam/sec-3/arc-sector-segment.webp",
        link: "/docs/exam-papers/sec-3/2. 7 ESSENTIAL QUESTIONS TO MASTER ARC SECTOR SEGMENT.pdf"
      },
      {
        title: "Coordinate Geometry",
        img: "/images/site/exam/sec-3/coordinate-geometry.webp",
        link: "/docs/exam-papers/sec-3/3. 10 ESSENTIAL QUESTIONS TO MASTER COORDINATE GEOMETRY.pdf"
      },
      {
        title: "HCF & LCM",
        img: "/images/site/exam/sec-3/hcf-and-lcm.webp",
        link: "/docs/exam-papers/sec-3/4. 9 ESSENTIAL QUESTIONS TO MASTER HCF & LCM.pdf"
      },
      {
        title: "Measuration",
        img: "/images/site/exam/sec-3/measuration.webp",
        link: "/docs/exam-papers/sec-3/5. 7 ESSENTIAL QUESTIONS TO MASTER MEASURATION.pdf"
      },
      {
        title: "Number Patterns",
        img: "/images/site/exam/sec-3/number-patterns.webp",
        link: "/docs/exam-papers/sec-3/6. 8 ESSENTIAL QUESTIONS TO MASTER NUMBER PATTERNS.pdf"
      },
      {
        title: "Proportions",
        img: "/images/site/exam/sec-3/proportions.webp",
        link: "/docs/exam-papers/sec-3/7. 8 ESSENTIAL QUESTIONS TO MASTER PROPORTIONS.pdf"
      },
      {
        title: "Trigonometry",
        img: "/images/site/exam/sec-3/trigonometry.webp",
        link: "/docs/exam-papers/sec-3/8. 8 ESSENTIAL QUESTIONS TO MASTER TRIGONOMETRY.pdf"
      },
  ]},
];

const Exams = (props) => {
  const examPaper = ExamPapers.find(paper => paper.id === props.id);
  return (
    <div className="main-page-wrapper p0">
      <Helmet>
        <title>
          {examPaper ? examPaper.level : ""} Exam Papers
        </title>
      </Helmet>
      
      <Header />
      
      {/* 	=============================================
				Fancy Hero Three
			============================================== */}
      <div className="fancy-hero-three bg-transparent mb-100">
        <div className="shapes shape-one"></div>
        <div className="shapes shape-two"></div>
        <div className="shapes shape-three"></div>
        <div className="shapes shape-four"></div>
        <div className="shapes shape-five"></div>
        <div className="shapes shape-six"></div>
        <div className="bg-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-xl-9 col-lg-10 col-md-10 m-auto">
                <h1 className="heading">{examPaper ? examPaper.level : ""} {examPaper ? examPaper.subject : ""}</h1>
                <p className="sub-heading">
                  {examPaper ? examPaper.subText : ""}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* /.bg-wrapper  */}
      </div>

      
      <div className="level-text-block-right level-secondary pt-50 pb-120 md-pt-50 md-pb-80">
        <div className="container">
          <div className="row">
            <div className="col-xl-7 col-lg-8">
              <div className="title-style-one mb-40 md-mb-20">
                <h2>{examPaper ? examPaper.header : ""}</h2>
                <p className="font-rubik">
                  {examPaper ? examPaper.subHeader : ""}
                </p>
              </div>
            </div>
          </div>

          <div className="wrapper">
            <div className="row justify-content-center">
              <ExamFeature exam={examPaper.items} level={examPaper.level} />
            </div>
          </div>

          <div className="wrapper">
            <div className="row justify-content-center">
              <WhatsAppEnquiryButton
                type="examPapers"
                source={"/exam-papers/"+examPaper.id}
                label="examPapersClickWhatsAppEnquire"
                action="Click"
                className="theme-btn-five mt-50 md-mt-30"
                level={examPaper.level+" "+examPaper.subject}
              />
            </div>
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default Exams;
